import clsx from 'clsx';
import { Loader } from 'components/UI/Loader';
import { ButtonHTMLAttributes, PropsWithChildren } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
	onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
	className?: string;
	loading?: boolean;
	active?: boolean;
	disabled?: boolean;
}

export const IconButton = ({
	children,
	onClick,
	className,
	loading,
	active,
	disabled,
	...props
}: PropsWithChildren<Props>) => {
	return (
		<button
			type="button"
			className={clsx(
				'flex items-center gap-2 rounded-full transition-colors disabled:text-gray-400 disabled:hover:bg-gray-500/10 disabled:cursor-not-allowed',
				!loading && 'p-4 hover:bg-gray-700/10',
				active && !disabled && 'text-primary-500',
				className
			)}
			onClick={onClick}
			disabled={loading || disabled}
			{...props}
		>
			{loading ? <Loader /> : children}
		</button>
	);
};
